import React, { useEffect, useState } from "react";
import Footer from "../../../Kryzen Alpha App/Components//Footer/footer";
import performRequest from "../../../Kryzen Alpha App/api/request";
import { Toast } from "../../../Kryzen Alpha App/CustomComponent/toast";
import { useDispatch, useSelector } from "react-redux";
import DynamicFilterInput from "../../../Kryzen Alpha App/Components/layouts/filter.inpit";
import DynamicFilterSelect from "../../../Kryzen Alpha App/Components/layouts/filter.select";
import getFilteredURL from "../../../Kryzen Alpha App/Components/Functions/filters.getUrl";
import Pagination from "../../Components/layouts/pagination";
import WaterManagementTable from "./Water Management/water_management_table";

import { FcDam } from "react-icons/fc";
import { BsWater } from "react-icons/bs";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import LoadingPage from "../../Components/layouts/loading";
import CustomViedoCard from "../../CustomComponent/custom_viedo_card";
import { useNavigate, useSearchParams } from "react-router-dom";
import {setWaterPage} from "../../redux/Pagination/pagination"
 
const FarmWaterManagement = () => {
  const store = useSelector((store) => store.login.user);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
    const dispatch = useDispatch();
    const page = useSelector((state) => state.pagination.waterPage);
  // const [page, setPage] = useState(1);
  const navigate = useNavigate();
  const [showPage, setShowPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [farmName, setFarmName] = useState();
  const [filters, setFilters] = useState({
    startdate: "",
    enddate: "",
    cycleName: "",
    farmName: "",
    archieveData: 0,
  });
  const [data, setData] = useState([]);
  const [themeSet, setThemeSet] = useState("");
  const [searchParams] = useSearchParams();
  const theme = searchParams.get("theme");
  const [checkClientAccess, setCheckClientAccess] = useState({
    workOrder: false,
    isHandOverCompleted: false,
    isClient: store?.Role == process.env.REACT_APP_ROLE_CLIENT,
  });
  const showArchived = filters.archieveData === 1;

  useEffect(() => {
    setLoading(true);
    performRequest(
      "GET",
      getFilteredURL("/projectTracking/getProjectTracking", 1)
    )
      .then((res) => {
        if (res.status === 200) {
          let access = {
            isHandOverCompleted: false,
            workOrder: false,
            isClient: false,
          };

          if (res?.data?.clientHandover?.handOverCertificate) {
            access.isHandOverCompleted = true;
          }
          if (res?.data?.projectTrackingData?.[0]?.workOrderUpload) {
            access.workOrder = true;
          }
          if (store?.Role == process.env.REACT_APP_ROLE_CLIENT) {
            access.isClient = true;
          }
          setCheckClientAccess(access);
        } else {
          Toast("error", "Error while getting Leads!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    setThemeSet(theme);
  }, [theme]);

  useEffect(() => {
    setLoading(true);
    performRequest(
      "GET",
      getFilteredURL("/waterManagement/getWaterManagement/", page, filters)
    )
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
          setTotalPages(Math.ceil(res.data?.waterManagementCount / 50));
        } else {
          Toast("error", "Error while getting Data!");
        }
      })
      .catch((err) => {
        // Toast("error", "Server Error!");
        // console.error(err);
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [refresh, page]);

  useEffect(() => {
    setLoading(true);
    performRequest("GET", "/clientProject/getCpNameForClients/")
      .then((res) => {
        if (res.status === 200) {
          setFarmName(res?.data?.clientProjectsData);
        } else {
          Toast("error", "Error while getting data!");
        }
      })
      .catch((err) => {
        // Toast("error", "Server Error!");
        // console.error(err);
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [refresh, page]);

  const navigateTocreateBatch = () => {
    if (
      checkClientAccess?.isClient &&
      !checkClientAccess?.isHandOverCompleted
    ) {
      data?.waterManagementData?.length > 0
        ? Toast(
            "error",
            "Your handover process is not completed yet. So, you cannot create new water cycle till that. Please contact Kryzen support team for more details."
          )
        : navigate("/farm-water-management/new");
    } else {
      navigate("/farm-water-management/new");
    }
  };
  if (loading) {
    return <LoadingPage />;
  }
  return (
    <>
      {checkClientAccess?.isClient && !checkClientAccess?.workOrder ? (
        <div className="page-wrapper">
          <div className="page-body">
            <div className="container-xxl d-flex flex-column justify-content-center">
              <div className="empty">
                <p className="empty-title">
                  Your farm has not been deployed yet.
                </p>
                <p className="empty-subtitle text-muted">
                  Contact your account manager.
                </p>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      ) : (
        <div className="page">
          <div className="page-wrapper">
            <div className="container-xxl">
              <div className="page-header d-print-none">
                <div className="row align-items-center">
                  <div className="col-md-8">
                    <h2 className="page-title mb-1">
                      <FcDam className="fs-2  me-1" /> Water Management
                    </h2>
                    <h4 className="text-muted">
                      {/* <StepRoutes /> */} Track & manage your water tanks.
                    </h4>
                  </div>
                  <div className="col-md-4 d-none d-sm-block">
                    <div className="btn-list justify-content-end">
                      <button
                        className="btn btn-primary"
                        onClick={navigateTocreateBatch}
                      >
                        {" "}
                        <BsWater className="fs-3 me-2" />
                        CREATE WATER CYCLE
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              {/* <div className="row">
              <div className="col-md-3 col-sm-12 py-2">
                <div className="card p-3">
                  <div className="row">
                    <h3 className="">Filter result</h3>
                    
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-9 col-sm-12 py-2">
                <div className="card">
                  
                </div>
              </div>
            </div> */}

              <div className="row">
                <div className="col-md-3 col-sm-12 py-2">
                  <div className="card p-2">
                    <div
                      id="faq-1"
                      className="accordion"
                      role="tablist"
                      aria-multiselectable="true"
                    >
                      <div>
                        <div className="accordion-header m-0" role="tab">
                          <button
                            className="accordion-button fs-3 d-md-none p-0"
                            data-bs-toggle="collapse"
                            data-bs-target="#faq-1-1"
                          >
                            <h3 className="m-1">Filter result</h3>
                          </button>
                        </div>

                        <div
                          id="faq-1-1"
                          className="accordion-collapse collapse d-md-none "
                          role="tabpanel"
                          data-bs-parent="#faq-1"
                        >
                          <div
                            className={`accordion-body pt-0 ${
                              themeSet === "dark" ? "text-light" : ""
                            }`}
                          >
                            <div className="row">
                              <div className="col-12">
                                <DynamicFilterInput
                                  label="Start Date:"
                                  value={filters.startdate}
                                  onChange={(e) =>
                                    setFilters({
                                      ...filters,
                                      startdate: e.target.value,
                                    })
                                  }
                                  type="date"
                                />
                              </div>
                              <div className="col-12">
                                <DynamicFilterInput
                                  label="End Date:"
                                  value={filters.enddate}
                                  onChange={(e) =>
                                    setFilters({
                                      ...filters,
                                      enddate: e.target.value,
                                    })
                                  }
                                  type="date"
                                />
                              </div>
                              <div className="col-12">
                                <DynamicFilterInput
                                  label="Search water cycle name:"
                                  value={filters.cycleName}
                                  onChange={(e) =>
                                    setFilters({
                                      ...filters,
                                      cycleName: e.target.value,
                                    })
                                  }
                                  placeholder="search name..."
                                />
                              </div>
                              <div className="col-12">
                                <DynamicFilterSelect
                                  label="Search type of system:"
                                  onChange={(e) =>
                                    setFilters({
                                      ...filters,
                                      typeOfSystem: e.target.value,
                                    })
                                  }
                                  value={filters.typeOfSystem}
                                >
                                  <option value="">select all</option>
                                  <option value="a-frame">A-Frame</option>
                                  <option value="flatBed">Flatbed</option>
                                  <option value="growBags">Growbags</option>
                                  <option value="dutchBucket">
                                    Dutch Bucket
                                  </option>
                                  <option value="indoorHydroponic">
                                    Indoor Hydroponic
                                  </option>
                                </DynamicFilterSelect>
                              </div>
                              {(store.Role ===
                                process.env.REACT_APP_ROLE_ADMIN_S ||
                                store.Role ===
                                  process.env.REACT_APP_ROLE_ADMIN) && (
                                <div className="col-12">
                                  <DynamicFilterSelect
                                    label="Search farm name:"
                                    onChange={(e) =>
                                      setFilters({
                                        ...filters,
                                        farmName: e.target.value,
                                      })
                                    }
                                    value={filters.farmName}
                                  >
                                    <option value="">select all</option>

                                    {farmName &&
                                      farmName?.map((state, index) => (
                                        <option
                                          key={index}
                                          value={state?.clientName}
                                        >
                                          {state?.clientName}
                                        </option>
                                      ))}
                                  </DynamicFilterSelect>
                                </div>
                              )}

                              <div className="col-12">
                                <div className="row mt-2">
                                  <div className="col-6">
                                    <button
                                      onClick={() => setRefresh(!refresh)}
                                      className="btn btn-success w-100"
                                    >
                                      Apply Filter
                                    </button>
                                  </div>
                                  <div className="col-6">
                                    <button
                                      onClick={() => {
                                        setFilters({
                                          startdate: "",
                                          enddate: "",
                                          cycleName: "",
                                          typeOfSystem: "",
                                          farmName: "",
                                          archieveData: 0,
                                        });
                                        setRefresh(!refresh);
                                      }}
                                      className="btn btn-secondary w-100"
                                    >
                                      Reset Filter
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className={`accordion-body d-none d-md-block ${
                            themeSet === "dark" ? "text-light" : ""
                          }`}
                        >
                          <div className="row">
                            <h3>Filter result</h3>
                            <div className="col-12">
                              <DynamicFilterInput
                                label="Start Date:"
                                value={filters.startdate}
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    startdate: e.target.value,
                                  })
                                }
                                type="date"
                              />
                            </div>
                            <div className="col-12">
                              <DynamicFilterInput
                                label="End Date:"
                                value={filters.enddate}
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    enddate: e.target.value,
                                  })
                                }
                                type="date"
                              />
                            </div>
                            <div className="col-12">
                              <DynamicFilterInput
                                label="Search water cycle name:"
                                value={filters.cycleName}
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    cycleName: e.target.value,
                                  })
                                }
                                placeholder="search name..."
                              />
                            </div>
                            <div className="col-12">
                              <DynamicFilterSelect
                                label="Search type of system:"
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    typeOfSystem: e.target.value,
                                  })
                                }
                                value={filters.typeOfSystem}
                              >
                                <option value="">select all</option>
                                <option value="a-frame">A-Frame</option>
                                <option value="flatBed">Flatbed</option>
                                <option value="growBags">Growbags</option>
                                <option value="dutchBucket">
                                  Dutch Bucket
                                </option>
                                <option value="indoorHydroponic">
                                  Indoor Hydroponic
                                </option>
                              </DynamicFilterSelect>
                            </div>
                            {(store.Role ===
                              process.env.REACT_APP_ROLE_ADMIN_S ||
                              store.Role ===
                                process.env.REACT_APP_ROLE_ADMIN) && (
                              <div className="col-12">
                                <DynamicFilterSelect
                                  label="Search farm name:"
                                  onChange={(e) =>
                                    setFilters({
                                      ...filters,
                                      farmName: e.target.value,
                                    })
                                  }
                                  value={filters.farmName}
                                >
                                  <option value="">select all</option>

                                  {farmName &&
                                    farmName?.map((state, index) => (
                                      <option
                                        key={index}
                                        value={state?.clientName}
                                      >
                                        {state?.clientName}
                                      </option>
                                    ))}
                                </DynamicFilterSelect>
                              </div>
                            )}

                            <div className="col-12">
                              <div className="row mt-2">
                                <div className="col-6">
                                  <button
                                    onClick={() => setRefresh(!refresh)}
                                    className="btn btn-success w-100"
                                  >
                                    Apply Filter
                                  </button>
                                </div>
                                <div className="col-6">
                                  <button
                                    onClick={() => {
                                      setFilters({
                                        startdate: "",
                                        enddate: "",
                                        cycleName: "",
                                        typeOfSystem: "",
                                        farmName: "",
                                        archieveData: 0,
                                      });
                                      setRefresh(!refresh);
                                    }}
                                    className="btn btn-secondary w-100"
                                  >
                                    Reset Filter
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mt-3 mb-3">
  {!showArchived && (
    <button
      onClick={() => {
        setFilters((prev) => ({ ...prev, archieveData: 1 }));
        dispatch(setWaterPage(1));
        setRefresh((r) => !r);
      }}
      className="btn btn-outline btn-danger w-100"
    >
      Archived Cycles
    </button>
  )}

  {showArchived && (
    <button
      onClick={() => {
        setFilters((prev) => ({ ...prev, archieveData: 0 }));
        dispatch(setWaterPage(1));
        setRefresh((r) => !r);
      }}
      className="btn btn-outline btn-success w-100"
    >
      Active Cycles
    </button>
  )}
</div>
                  <div className="d-none d-lg-block d-md-block mb-2">
                    <CustomViedoCard
                      viedoLink={"https://www.youtube.com/embed/AnQYLsE26CU"}
                      id={"model-viedo"}
                      name={"water management"}
                    ></CustomViedoCard>
                  </div>
                </div>
                
                <div className="col-md-9 col-sm-12 py-2">
                  
                  <div className="card">
                    {
                      <WaterManagementTable
                        data={data?.waterManagementData}
                        currentPage={page}
                        itemsPerPage={50}
                        showArchived={showArchived}
                        onActionComplete={() => setRefresh((r) => !r)}
                      />
                    }

                    <div className="btn-list justify-content-center">
                      <div className="d-lg-none d-md-none mt-3 mb-3">
                        <button
                          onClick={navigateTocreateBatch}
                          className="btn btn-primary"
                        >
                          {" "}
                          <BsWater className="fs-3 me-2" />
                          CREATE WATER CYCLE
                        </button>
                      </div>
                    </div>

                    <Pagination
                      page={page}
                      setPage={(newPage) => dispatch(setWaterPage(newPage))}
                      totalPages={totalPages}
                      pageDatalength={data?.waterManagementData?.length}
                      showPage={showPage}
                      setShowPage={setShowPage}
                    />
                  </div>
                </div>
              </div>
              <div className="d-block d-lg-none d-md-none ms-2 me-2">
                <CustomViedoCard
                  viedoLink={"https://www.youtube.com/embed/AnQYLsE26CU"}
                  id={"model-viedo2"}
                  name={"water management"}
                ></CustomViedoCard>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      )}
    </>
  );
};

export default FarmWaterManagement;
